<template>
  <!-- :class="notice.moveType == 'move-left' ? 'bubble_Tips_left':'bubble_Tips_right'" -->
  <div :class="classes"
       :style="wrapStyles"
       class="bubble_Tips">
    <div v-if="status == 0 && shownotices.length != 0"
         class="bubble_close_tips"
         @click="closeTips">{{shownotices[0].closeReminder}}</div>
    <Notice v-for="(notice) in shownotices"
            :key="notice.name"
            :prefix-cls="prefixCls"
            :styles="notice.styles"
            :moveType="notice.moveType"
            :duration="notice.duration"
            :render="notice.render"
            :has-title="notice.hasTitle"
            :withIcon="notice.withIcon"
            :closable="notice.closable"
            :name="notice.name"
            :title="notice.title"
            :action="notice.action"
            :volume="notice.volume"
            :icon="notice.icon"
            :locale="notice.locale"
            :transition-name="notice.transitionName"
            :on-close="notice.onClose"
            :tipsType="notice.tipsType"
            :on-click="notice.onClick"
            :on-mounted="notice.onMounted"
            :class="notice.moveType == 'leftToright'?'bubble_Tips_left':'bubble_Tips_right'">
    </Notice>
  </div>
</template>
<script>
import bus from '../../../../utils/bus'
import Notice from './notice';
import { transferIndex, transferIncrease } from '../transfer-queue';
const prefixCls = 'ivu-notification';
let seed = 0;
const now = Date.now();

function getUuid () {
  return 'ivuNotification_' + now + '_' + (seed++);
}
export default {
  // :style="{bottom:((shownotices.length-index-1)*70)+'px'}"
  components: { Notice },
  props: {
    prefixCls: {
      type: String,
      default: prefixCls
    },
    status: {
      type: Number,
      default: status
    },
    styles: {
      type: Object,
      default: function () {
        return {
          top: '65px',
          left: '50%'
        };
      }
    },
    content: {
      type: String
    },
    bubbleType: {
      type: Number
    },
    className: {
      type: String
    }
  },
  data () {
    return {
      notices: [],
      shownotices: [],
      tIndex: this.handleGetIndex()
    };
  },
  computed: {
    classes () {
      return [
        `${this.prefixCls}`,
        `${this.prefixCls}_${this.status}`,
        {
          [`${this.className}`]: !!this.className
        }
      ];
    },
    wrapStyles () {
      // this.styles.top = 'inherit';
      // this.styles.bottom = '45px';
      let styles = Object.assign({}, this.styles);
      styles['z-index'] = 1010 + this.tIndex;
      return styles;
    }
  },
  methods: {
    add (notice) {
      const name = notice.name || getUuid();
      let _notice = Object.assign({
        styles: {
          right: '50%'
        },
        content: '',
        duration: 1.5,
        closable: false,
        name: name
      }, notice);
      //将申请的气泡放到正在讲话的人前面
      if (_notice.bubbleType != undefined && _notice.bubbleType == 0) {
        let noticesIndex = this.notices.findIndex((noticeInfo) => { return noticeInfo.bubbleType == 1 });
        if (noticesIndex != -1) {
          this.notices.splice(noticesIndex, 0, _notice)
        } else {
          this.notices.push(_notice)
        }
      } else {
        this.notices.push(_notice);
      }
      this.shownotices = this.notices.slice(0, this.notices.length)
      this.tIndex = this.handleGetIndex();
    },
    close (name) {
      const notices = this.notices;
      for (let i = 0; i < notices.length; i++) {
        if (notices[i].name === name) {
          // console.log(notices[i].title = '2人');
          this.notices.splice(i, 1);
          break;
        }
      };
      // if(this.notices.length >6){
      //   this.shownotices  = this.notices.slice(0,6)
      // }else{
      this.shownotices = this.notices.slice(0, this.notices.length)
      // }
    },
    changeTitle (name, title) {
      const notices = this.notices;
      for (let i = 0; i < notices.length; i++) {
        if (notices[i].name === name) {
          notices[i].title = title;
          break;
        }
      };
    },
	getLength(){
		return this.notices.length
	},
    removeAllSpeaking (action) {
      //        	  console.log(action);
      let notices = this.notices;
      this.shownotices = notices.reduce((total, current) => {
        current.action !== action && total.push(current);
        return total;
      }, []);
      //            console.log(this.notices);
    },
    /**如果传入的讲话列表中的数据没有在气泡列表中，那么删除在气泡中的列表**/
    removeSpeaking (speakList) {
      for (var i = 0; i < this.notices.length; i++) {
        if (this.notices[i].bubbleType == 1) {
          let CurInfo = speakList.find((info) => { return info.ptid == this.notices[i].ptid });
          if (!CurInfo) {
            this.notices.splice(i--, 1);
          }
        }
      }
      this.shownotices = this.notices;
    },
    removeExitSpeaking (ptid) {
      //         	 console.log(this.notices);
      let i = this.notices.length;
      while (i--) {
        if (this.notices[i].ptid && this.notices[i].ptid == ptid) {
          this.notices.splice(i, 1);
        }
      }
      this.shownotices = this.notices;
    },
    findChangeBubble (ptid, volume) {
      //          	console.log(ptid);
      //          	console.log(this.notices)
      var noticeInfo = this.notices.find((noticeInfo) => { return noticeInfo && noticeInfo.ptid == ptid });
      //          	 console.log(noticeInfo);
      if (noticeInfo) {
        noticeInfo.volume = volume;
        //          	 	console.log(noticeInfo);
        return true
      } else {
        return false
      }

    },
    changeVolume (ptid, Volume) {
      const notices = this.notices;
      for (let i = 0; i < notices.length; i++) {
        if (notices[i].ptid && notices[i].ptid === ptid) {
          notices[i].volume = volume;
          break;
        }
      };
    },
    closeTips () {
      bus.$emit('closeTips')
    },
    closeAll () {
      this.notices = [];
      this.shownotices = [];
    },
    handleGetIndex () {
      transferIncrease();
      return transferIndex;
    },
  }
};
</script>
